import { i } from "./index-DW0Ysnor.mjs";
import { i as i2 } from "./index-CXpBEYSc.mjs";
import { i as i3 } from "./index-BX_D-pjb.mjs";
import { i as i4 } from "./index-BQLK1nAJ.mjs";
import { c as componentNames, a as componentsWithExternalPath, b as composableNames, d as composablesWithExternalPath, e as directiveNames, f as directivesWithExternalPath } from "./index-DkI9t_-4.mjs";
import { B, i as i5 } from "./index-DkI9t_-4.mjs";
import { i as i6 } from "./index-DwDHvBIQ.mjs";
import { _, a } from "./BAccordionItem.vue_vue_type_script_setup_true_lang-AgwEJ73c.mjs";
import { _ as _2, a as a2 } from "./BAvatarGroup.vue_vue_type_script_setup_true_lang-5PBAGGTP.mjs";
import { _ as _3 } from "./BBadge.vue_vue_type_script_setup_true_lang-BQbv5hMw.mjs";
import { _ as _4, a as a3 } from "./BBreadcrumb.vue_vue_type_script_setup_true_lang-CRIZoZeV.mjs";
import { _ as _5 } from "./BButton.vue_vue_type_script_setup_true_lang-CywtlN38.mjs";
import { _ as _6, a as a4 } from "./BButtonToolbar.vue_vue_type_script_setup_true_lang-qymZ6O0g.mjs";
import { _ as _7 } from "./BCloseButton.vue_vue_type_script_setup_true_lang-DjJD_nYp.mjs";
import { _ as _8, a as a5, b, c, d, e, f } from "./BCard.vue_vue_type_script_setup_true_lang-DXWrClcW.mjs";
import { _ as _9, a as a6 } from "./BCardText.vue_vue_type_script_setup_true_lang-VEvK_j1X.mjs";
import { _ as _10, a as a7 } from "./BCarouselSlide.vue_vue_type_script_setup_true_lang-C38VxQgW.mjs";
import { _ as _11 } from "./BCollapse.vue_vue_type_script_setup_true_lang-vGXlzSIV.mjs";
import { _ as _12 } from "./BCol.vue_vue_type_script_setup_true_lang-suozSq48.mjs";
import { _ as _13 } from "./BContainer.vue_vue_type_script_setup_true_lang-amTLVjJN.mjs";
import { _ as _14 } from "./BRow.vue_vue_type_script_setup_true_lang-0hLWSzY1.mjs";
import { _ as _15 } from "./BDropdown.vue_vue_type_script_setup_true_lang-BPR8NXKb.mjs";
import { _ as _16, a as a8, b as b2, c as c2, d as d2, e as e2, f as f2 } from "./BDropdownText.vue_vue_type_script_setup_true_lang-BDwerYPM.mjs";
import { _ as _17 } from "./BForm.vue_vue_type_script_setup_true_lang-47Vj3UA2.mjs";
import { _ as _18, a as a9 } from "./BFormFloatingLabel.vue_vue_type_script_setup_true_lang-CIeh0lsL.mjs";
import { _ as _19, a as a10, b as b3, c as c3 } from "./BFormValidFeedback.vue_vue_type_script_setup_true_lang-xcsogHHN.mjs";
import { _ as _20, a as a11 } from "./BFormCheckboxGroup.vue_vue_type_script_setup_true_lang-qmX0MPIN.mjs";
import { _ as _21 } from "./BFormFile.vue_vue_type_script_setup_true_lang-C7MTQF1-.mjs";
import { _ as _22 } from "./BFormGroup.vue_vue_type_script_setup_true_lang-KPW5o1XV.mjs";
import { _ as _23, _ as _24 } from "./BFormInput.vue_vue_type_script_setup_true_lang-C8Wa81cB.mjs";
import { _ as _25, a as a12 } from "./BFormRadioGroup.vue_vue_type_script_setup_true_lang-u-EudL9M.mjs";
import { _ as _26, a as a13 } from "./BFormSelect.vue_vue_type_script_setup_true_lang-B2LqCugy.mjs";
import { _ as _27 } from "./useFormSelect-DAr__bvr.mjs";
import { _ as _28 } from "./BFormSpinbutton.vue_vue_type_script_setup_true_lang-D2L1cFug.mjs";
import { a as a14, _ as _29 } from "./BFormTags.vue_vue_type_script_setup_true_lang-BTvSD2lh.mjs";
import { _ as _30 } from "./BFormTextarea.vue_vue_type_script_setup_true_lang-3ZSab3T0.mjs";
import { _ as _31 } from "./BImg.vue_vue_type_script_setup_true_lang-BeMDI0oP.mjs";
import { _ as _32, a as a15 } from "./BInputGroupText.vue_vue_type_script_setup_true_lang-B11o7IpN.mjs";
import { _ as _33 } from "./BLink.vue_vue_type_script_setup_true_lang-DTMTuVcR.mjs";
import { _ as _34, a as a16 } from "./BListGroupItem.vue_vue_type_script_setup_true_lang-BNWW9tJp.mjs";
import { _ as _35, a as a17 } from "./BModalOrchestrator.vue_vue_type_script_setup_true_lang-DtHGvqlM.mjs";
import { _ as _36, a as a18, b as b4, c as c4, d as d3 } from "./BNavText.vue_vue_type_script_setup_true_lang-B4Z1FrCG.mjs";
import { _ as _37, a as a19, b as b5, c as c5 } from "./BNavbarToggle.vue_vue_type_script_setup_true_lang-ByQQnRp5.mjs";
import { _ as _38 } from "./BOverlay.vue_vue_type_script_setup_true_lang-BNagP-aH.mjs";
import { _ as _39 } from "./BPagination.vue_vue_type_script_setup_true_lang-l5GT5VPN.mjs";
import { _ as _40, a as a20, b as b6, c as c6, d as d4 } from "./BPlaceholderWrapper.vue_vue_type_script_setup_true_lang-B13c8VVG.mjs";
import { _ as _41 } from "./BPopoverOrchestrator.vue_vue_type_script_setup_true_lang-BADk7-n8.mjs";
import { _ as _42, a as a21 } from "./BProgress.vue_vue_type_script_setup_true_lang-Bft5GlO-.mjs";
import { _ as _43 } from "./BSpinner.vue_vue_type_script_setup_true_lang-BtYfD0A-.mjs";
import { _ as _44, a as a22, b as b7, c as c7, d as d5, e as e3, f as f3, g } from "./BTable.vue_vue_type_script_setup_true_lang-CYs9k7_p.mjs";
import { _ as _45 } from "./BTableSimple.vue_vue_type_script_setup_true_lang-N6nsvv6z.mjs";
import { _ as _46, a as a23 } from "./BTabs.vue_vue_type_script_setup_true_lang-BHo2I5wE.mjs";
import { B as B2, _ as _47 } from "./BToastOrchestrator.vue_vue_type_style_index_0_lang-qQXgn_O_.mjs";
import { _ as _48 } from "./BTooltip.vue_vue_type_script_setup_true_lang-27IZ7bOv.mjs";
import { useBreadcrumb } from "./src/composables/useBreadcrumb/index.mjs";
import { useColorMode } from "./src/composables/useColorMode/index.mjs";
import { useModal } from "./src/composables/useModal/index.mjs";
import { useModalController } from "./src/composables/useModalController/index.mjs";
import { useScrollspy } from "./src/composables/useScrollspy/index.mjs";
import { useToastController } from "./src/composables/useToastController/index.mjs";
import { useToggle } from "./src/composables/useToggle/index.mjs";
import { usePopoverController } from "./src/composables/usePopoverController/index.mjs";
import { vBColorMode } from "./src/directives/BColorMode/index.mjs";
import { vBToggle, vBToggle as vBToggle2 } from "./src/directives/BToggle/index.mjs";
import { vBPopover } from "./src/directives/BPopover/index.mjs";
import { vBScrollspy } from "./src/directives/BScrollspy/index.mjs";
import { vBTooltip } from "./src/directives/BTooltip/index.mjs";
import { b as b8, B as B3, a as a24 } from "./classes-B4vxmOuN.mjs";
import { B as B4 } from "./BAlert-t4xRB7pC.mjs";
import { B as B5 } from "./BOffcanvas-DH1MW9Or.mjs";
import { B as B6 } from "./floatingUi-D2mifeW0.mjs";
import { bootstrapPlugin } from "./src/plugins/bootstrap/index.mjs";
import { breadcrumbPlugin } from "./src/plugins/breadcrumb/index.mjs";
import { createBootstrap } from "./src/plugins/createBootstrap/index.mjs";
import { modalControllerPlugin } from "./src/plugins/modalController/index.mjs";
import { modalManagerPlugin } from "./src/plugins/modalManager/index.mjs";
import { popoverPlugin } from "./src/plugins/popoverController/index.mjs";
import { rtlPlugin } from "./src/plugins/rtl/index.mjs";
import { toastPlugin } from "./src/plugins/toastController/index.mjs";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  componentNames,
  componentsWithExternalPath,
  composableNames,
  composablesWithExternalPath,
  directiveNames,
  directivesWithExternalPath
}, Symbol.toStringTag, { value: "Module" }));
export {
  _ as BAccordion,
  a as BAccordionItem,
  B4 as BAlert,
  _2 as BAvatar,
  a2 as BAvatarGroup,
  _3 as BBadge,
  _4 as BBreadcrumb,
  a3 as BBreadcrumbItem,
  _5 as BButton,
  _6 as BButtonGroup,
  a4 as BButtonToolbar,
  _8 as BCard,
  a5 as BCardBody,
  b as BCardFooter,
  _9 as BCardGroup,
  c as BCardHeader,
  d as BCardImg,
  e as BCardSubtitle,
  a6 as BCardText,
  f as BCardTitle,
  _10 as BCarousel,
  a7 as BCarouselSlide,
  _7 as BCloseButton,
  _12 as BCol,
  _11 as BCollapse,
  _13 as BContainer,
  _15 as BDropdown,
  _16 as BDropdownDivider,
  a8 as BDropdownForm,
  b2 as BDropdownGroup,
  c2 as BDropdownHeader,
  d2 as BDropdownItem,
  e2 as BDropdownItemButton,
  f2 as BDropdownText,
  _17 as BForm,
  _20 as BFormCheckbox,
  a11 as BFormCheckboxGroup,
  _18 as BFormDatalist,
  _21 as BFormFile,
  a9 as BFormFloatingLabel,
  _22 as BFormGroup,
  _23 as BFormInput,
  _19 as BFormInvalidFeedback,
  _25 as BFormRadio,
  a12 as BFormRadioGroup,
  a10 as BFormRow,
  _26 as BFormSelect,
  _27 as BFormSelectOption,
  a13 as BFormSelectOptionGroup,
  _28 as BFormSpinbutton,
  a14 as BFormTag,
  _29 as BFormTags,
  b3 as BFormText,
  _30 as BFormTextarea,
  c3 as BFormValidFeedback,
  _31 as BImg,
  _24 as BInput,
  _32 as BInputGroup,
  a15 as BInputGroupText,
  _33 as BLink,
  _34 as BListGroup,
  a16 as BListGroupItem,
  _35 as BModal,
  a17 as BModalOrchestrator,
  _36 as BNav,
  a18 as BNavForm,
  b4 as BNavItem,
  c4 as BNavItemDropdown,
  d3 as BNavText,
  _37 as BNavbar,
  a19 as BNavbarBrand,
  b5 as BNavbarNav,
  c5 as BNavbarToggle,
  B5 as BOffcanvas,
  _38 as BOverlay,
  _39 as BPagination,
  _40 as BPlaceholder,
  a20 as BPlaceholderButton,
  b6 as BPlaceholderCard,
  c6 as BPlaceholderTable,
  d4 as BPlaceholderWrapper,
  B6 as BPopover,
  _41 as BPopoverOrchestrator,
  _42 as BProgress,
  a21 as BProgressBar,
  _14 as BRow,
  _43 as BSpinner,
  _46 as BTab,
  _44 as BTable,
  a22 as BTableLite,
  _45 as BTableSimple,
  a23 as BTabs,
  b7 as BTbody,
  c7 as BTd,
  d5 as BTfoot,
  e3 as BTh,
  f3 as BThead,
  B2 as BToast,
  _47 as BToastOrchestrator,
  _48 as BTooltip,
  g as BTr,
  B as BootstrapVueNextResolver,
  b8 as BvCarouselEvent,
  B3 as BvEvent,
  a24 as BvTriggerableEvent,
  i4 as Components,
  i as Composables,
  i2 as Directives,
  i6 as Plugins,
  i5 as Resolvers,
  index as Types,
  i3 as Utils,
  bootstrapPlugin,
  breadcrumbPlugin,
  componentNames,
  componentsWithExternalPath,
  composableNames,
  composablesWithExternalPath,
  createBootstrap,
  directiveNames,
  directivesWithExternalPath,
  modalControllerPlugin,
  modalManagerPlugin,
  popoverPlugin,
  rtlPlugin,
  toastPlugin,
  useBreadcrumb,
  useColorMode,
  useModal,
  useModalController,
  usePopoverController,
  useScrollspy,
  useToastController,
  useToggle,
  vBColorMode,
  vBToggle as vBModal,
  vBPopover,
  vBScrollspy,
  vBToggle2 as vBToggle,
  vBTooltip
};
//# sourceMappingURL=bootstrap-vue-next.mjs.map
